import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Divider } from '@material-ui/core';
import { MenuWarbox } from 'src/components/MenuWarbox';
import { UserInfo } from './UserInfo';

/**
 * Represents the menu content for the dashboard layout.
 *
 * @return {*}
 */
export const MenuContent = () => {
    return (
        <Box height="100%" display="flex" flexDirection="column">
            <UserInfo />
            <Divider />
            <PerfectScrollbar options={{ suppressScrollX: true }}>
                <MenuWarbox />
            </PerfectScrollbar>
        </Box>
    );
};
